import getConfig from 'next/config'

type FeatureFlagsRecord = Record<string, boolean | undefined>

/**
 * Gets the current config and picks off a feature flags object via the Next.js {@link getConfig} function.
 * If no feature flags are present, will return an empty object.
 *
 * @returns {FeatureFlagsRecord} Feature flags list - a record of feature flag keys mapped to booleans.
 * Keys are not guaranteed to exist on any given environment; if absent, lookups will return `undefined`.
 */
const getFeatureFlags = (): FeatureFlagsRecord =>
  getConfig()?.publicRuntimeConfig?.featureFlags ?? {}

export type { FeatureFlagsRecord }
export default getFeatureFlags
